export default {
    data () {
        return {

            headers: { Authorization: localStorage.getItem('Authorization')},

        }
    },

    methods: {
        posterAPI_create(fileName) {
            return this.axios.post(`${process.env.VUE_APP_ROOT_API}/api/posters/`, {fileName: fileName}, {headers: this.headers});
        },

        async posterAPI_get_all() {
            let posters = await this.axios.get(`${process.env.VUE_APP_ROOT_API}/api/posters/`);
            return posters.data;
        },

        posterAPI_delete(posterId) {
            return this.axios.delete(`${process.env.VUE_APP_ROOT_API}/api/posters/${posterId}`, {headers: this.headers});
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/api/posterAPI.js